import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/icons/icon_akbars.svg'
import _imports_1 from '../assets/icons/icon_alfabank.svg'
import _imports_2 from '../assets/icons/icon_blanc.svg'
import _imports_3 from '../assets/icons/icon_delobank.svg'
import _imports_4 from '../assets/icons/icon_gazprombank.svg'
import _imports_5 from '../assets/icons/icon_hicebank.svg'
import _imports_6 from '../assets/icons/icon_modulbank.svg'
import _imports_7 from '../assets/icons/icon_mtsbank.svg'
import _imports_8 from '../assets/icons/icon_open.svg'
import _imports_9 from '../assets/icons/icon_psbank.svg'
import _imports_10 from '../assets/icons/icon_rshb.svg'
import _imports_11 from '../assets/icons/icon_sberbank.svg'
import _imports_12 from '../assets/icons/icon_tinkoff.svg'
import _imports_13 from '../assets/icons/icon_uralsib.svg'
import _imports_14 from '../assets/icons/icon_vtb.svg'


const _hoisted_1 = { class: "wrapper w-full mt-35px h-90px <sm:h-50px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "vert-center" }, [
      _createElementVNode("span", { class: "uppercase text-36px <lg:text-24px <sm:text-18px font-500 gold-text-gradient" }, "Наши партнёры")
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_swiper, {
        slidesPerView: _ctx.amountOfSlides,
        loopedSlides: 5,
        loop: true,
        spaceBetween: _ctx.spaceBetweenSlides,
        freeMode: true,
        speed: 5000,
        autoplay: {
          delay: 500,
          disableOnInteraction: true,
        },
        class: "h-80px cursor-move"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_swiper_slide, null, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                src: _imports_0,
                class: ""
              }, null, -1)
            ])),
            _: 1
          }),
          _createVNode(_component_swiper_slide, null, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createElementVNode("img", {
                src: _imports_1,
                class: ""
              }, null, -1)
            ])),
            _: 1
          }),
          _createVNode(_component_swiper_slide, null, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("img", {
                src: _imports_2,
                class: ""
              }, null, -1)
            ])),
            _: 1
          }),
          _createVNode(_component_swiper_slide, null, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createElementVNode("img", {
                src: _imports_3,
                class: ""
              }, null, -1)
            ])),
            _: 1
          }),
          _createVNode(_component_swiper_slide, null, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createElementVNode("img", {
                src: _imports_4,
                class: ""
              }, null, -1)
            ])),
            _: 1
          }),
          _createVNode(_component_swiper_slide, null, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createElementVNode("img", {
                src: _imports_5,
                class: ""
              }, null, -1)
            ])),
            _: 1
          }),
          _createVNode(_component_swiper_slide, null, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createElementVNode("img", {
                src: _imports_6,
                class: ""
              }, null, -1)
            ])),
            _: 1
          }),
          _createVNode(_component_swiper_slide, null, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createElementVNode("img", {
                src: _imports_7,
                class: ""
              }, null, -1)
            ])),
            _: 1
          }),
          _createVNode(_component_swiper_slide, null, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createElementVNode("img", {
                src: _imports_8,
                class: ""
              }, null, -1)
            ])),
            _: 1
          }),
          _createVNode(_component_swiper_slide, null, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createElementVNode("img", {
                src: _imports_9,
                class: ""
              }, null, -1)
            ])),
            _: 1
          }),
          _createVNode(_component_swiper_slide, null, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createElementVNode("img", {
                src: _imports_10,
                class: ""
              }, null, -1)
            ])),
            _: 1
          }),
          _createVNode(_component_swiper_slide, null, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [
              _createElementVNode("img", {
                src: _imports_11,
                class: ""
              }, null, -1)
            ])),
            _: 1
          }),
          _createVNode(_component_swiper_slide, null, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [
              _createElementVNode("img", {
                src: _imports_12,
                class: ""
              }, null, -1)
            ])),
            _: 1
          }),
          _createVNode(_component_swiper_slide, null, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [
              _createElementVNode("img", {
                src: _imports_13,
                class: ""
              }, null, -1)
            ])),
            _: 1
          }),
          _createVNode(_component_swiper_slide, null, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [
              _createElementVNode("img", {
                src: _imports_14,
                class: ""
              }, null, -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["slidesPerView", "spaceBetween"])
    ])
  ]))
}